module.exports = __webpack_public_path__ + "assets/images/Sync2.33c06f4b.jpg";